import Styles from "./History.module.scss";
import clsx from "clsx";
import Select from "react-select";
import PaginationComponent from "../../../Share/Component/Pagination";
import TableComponent from "../../../Share/Component/Table";
import { formatType, formatDate } from "../../../Utils/index";
import {
  HISTORY_PAYMENT_TYPES,
  HISTORY_TABLE_COLUMNS,
} from "../../../Constants/history";
import { useHistoryPage } from "../../../Hooks/useHistoryPage";
import AdminModal from "../../../Components/Atoms/Modal";
import CreateInvoiceForm from "../../../Components/Molecules/CreateInvoiceForm";

function AdminHistory() {
  const {
    histories,
    search,
    type,
    paging,
    viewingId,
    creatingId,
    showCreateInvoiceModal,
    invoiceHistory,
    sepayEvent,
    isCreatingInvoice,
    getListHistories,
    setSearch,
    handleSelectType,
    handleViewInvoice,
    handleOpenCreateInvoice,
    handleCloseCreateInvoiceModal,
    handleCreateInvoice,
  } = useHistoryPage();
  const formatReferenceAmount = (number) => {
    if (!number) return "";
    return number.toLocaleString("vi-VN");
  };

  const getMisaInvoiceStatusClass = (value) => {
    if (value === "Success") return Styles.statusSuccess;
    if (value === "Pending") return Styles.statusPending;
    return Styles.statusFailed;
  };

  const formatMisaInvoiceStatus = (value) => {
    if (!value) return "";

    return (
      <span
        className={clsx(Styles.statusBadge, getMisaInvoiceStatusClass(value))}
      >
        {value}
      </span>
    );
  };

  const formatInvoiceAction = (row, _key) => {
    const invoiceStatus = String(row.MisaInvoiceStatus || "").toLowerCase();
    const canCreate =
      (invoiceStatus === "failed" || invoiceStatus === "fail") &&
      row.SepayEventId != null;
    const canView =
      row.MisaInvoiceStatus === "Success" && Boolean(row.MisaTransactionId);
    const isViewing = viewingId === row.Id;

    if (canCreate) {
      const isCreating = creatingId === row.Id;
      return (
        <button
          type="button"
          disabled={isCreating}
          className={clsx(Styles.invoiceButton, Styles.createInvoiceButton)}
          onClick={(event) => {
            event.stopPropagation();
            if (isCreating) return;
            handleOpenCreateInvoice(row);
          }}
        >
          {isCreating ? "Đang tải..." : "Tạo hóa đơn"}
        </button>
      );
    }

    if (row.MisaInvoiceStatus !== "Success") return "";

    return (
      <button
        type="button"
        disabled={!canView || isViewing}
        className={clsx(Styles.invoiceButton, Styles.viewInvoiceButton)}
        onClick={(event) => {
          event.stopPropagation();
          if (!canView || isViewing) return;
          handleViewInvoice(row);
        }}
      >
        {isViewing ? "Đang tải..." : "Xem hóa đơn"}
      </button>
    );
  };
  return (
    <div className={clsx(Styles.main, "flex-grow-1")}>
      <div className={clsx(Styles.bodyMain, "container-fluid my-1")}>
        <div className={clsx(Styles.bodyMainTop)}>
          <div className={clsx(Styles.filterWrap)}>
            <div className={clsx(Styles.searchWrap)}>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className={clsx(Styles.search)}
              />
              <span
                onClick={() => getListHistories(0)}
                className={clsx(Styles.contentSearch)}
              >
                Search
              </span>
            </div>
          </div>
          <div className={clsx(Styles.typeWrap)}>
            <Select
              value={type}
              onChange={handleSelectType}
              options={HISTORY_PAYMENT_TYPES}
            />
          </div>
        </div>
        <div className={clsx(Styles.table)} id="style-3">
          <TableComponent
            data={histories}
            header={HISTORY_TABLE_COLUMNS}
            customFormatters={{
              ReferenceAmount: formatReferenceAmount,
              CreatedDate: formatDate,
              Type: formatType,
              MisaInvoiceStatus: formatMisaInvoiceStatus,
              InvoiceAction: formatInvoiceAction,
            }}
          />
        </div>
        <div className={clsx(Styles.footer)}>
          <div className={clsx(Styles.footerWrap)}>
            <PaginationComponent
              page={paging}
              handleCallApi={getListHistories}
            />
          </div>
        </div>
      </div>
      {showCreateInvoiceModal && (
        <AdminModal
          title="Tạo hóa đơn"
          isShow={showCreateInvoiceModal}
          handleCloseModal={handleCloseCreateInvoiceModal}
        >
          <CreateInvoiceForm
            history={invoiceHistory}
            sepayEvent={sepayEvent}
            isSubmitting={isCreatingInvoice}
            onSubmit={handleCreateInvoice}
          />
        </AdminModal>
      )}
    </div>
  );
}

export default AdminHistory;
